export default __webpack_public_path__ + "static/retreat_10-dc20f8894c31404390a82181b77e30df.jpg";